import { toast } from 'react-toastify';
import { Alert, Avatar as AvatarMui, Skeleton, Stack, styled, Typography } from '@mui/material';

import { BotIcon } from 'assets/icons/BotIcon';
import { CopyIcon } from 'assets/icons/Copy';
import { ReloadIcon } from 'assets/icons/ReloadIcon';
import { IconButton } from 'components/base/IconButton';

const BotMessageStack = styled(Stack)`
  max-width: 600px;
  margin: 40px auto 40px 0;
`;

const Avatar = styled(AvatarMui)`
  background: #fff;
  margin-right: 16px;

  svg {
    width: 34px;
    height: 34px;
    fill: ${({ theme }) => theme.palette.primary.main};
  }
`;

interface IBotMessageProps {
  message?: {
    text?: string;
    date?: string;
    rol?: 'bot';
    chatId?: string;
    error?: string;
  };
  loading?: boolean;
  refetch?: () => void;
}

export const BotMessage = ({ message = {}, loading, refetch }: IBotMessageProps) => {
  const { text, error } = message;

  const copyText = () => {
    navigator.clipboard.writeText(text);

    toast.success('Text copied to clipboard successfully!', {
      position: 'top-right',
      autoClose: 1500,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'light',
    });
  };

  return (
    <BotMessageStack direction="row">
      <Avatar color="primary">
        <BotIcon />
      </Avatar>
      {text && (
        <Stack>
          <Typography
            variant="body1"
            sx={{
              whiteSpace: 'break-spaces',
            }}
            dangerouslySetInnerHTML={{
              __html: text.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>'),
            }}
          />

          <IconButton
            color="primary"
            onClick={copyText}
          >
            <CopyIcon />
          </IconButton>
        </Stack>
      )}
      {loading && (
        <Skeleton
          animation="wave"
          width={2000}
          height={45}
        />
      )}
      {error && (
        <Stack>
          <Alert
            severity="error"
            sx={{
              background: (theme) => theme.palette.error.lightest,
              color: (theme) => theme.palette.error.main,
              borderRadius: '12px',
            }}
          >
            {error}
          </Alert>
          <IconButton
            color="primary"
            onClick={refetch}
          >
            <ReloadIcon />
          </IconButton>
        </Stack>
      )}
    </BotMessageStack>
  );
};
